import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import type { OpportunityType } from '@/api/opportunity';
import { Link } from '@/components/typography';
import WarningPopover from '@/components/WarningPopover';
import { isDomainValidForOpportunity } from '@/helper/validator';

type Props = {
  opportunity: OpportunityType;
};

const OpportunityDomainCell = ({ opportunity }: Props) => {
  const tld = opportunity.account.company?.tld ?? opportunity.account.tld;
  const isValidDomain = tld && isDomainValidForOpportunity(tld);

  if (isValidDomain) {
    return tld;
  }

  return (
    <div className="-my-1 flex items-center gap-1">
      <WarningPopover
        placement="left"
        size="medium"
        title={tld == null ? t`No domain found` : t`Invalid domain`}
        body={
          <>
            {tld == null && (
              <Trans>
                No website was found on the account record, please update the CRM Account record
                with a valid website so digital visits can be attributed.
              </Trans>
            )}
            {tld && !isValidDomain && (
              <Trans>
                This account's website has an unrecognized character, is missing a top-level domain
                (.com, .edu, .org), or starts with "www.". Please update the website field on the
                CRM Account to a valid value (e.g. example.com).
              </Trans>
            )}
            <br />
            <Link variant="body2" color="static-green" to={opportunity.sfUrl} target="_blank">
              <Trans>Update Website HERE.</Trans>
            </Link>
          </>
        }
      />
      {tld != null && tld}
    </div>
  );
};

export default OpportunityDomainCell;
